import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import { getMinDate, getNowDateFormatWithoutTime } from '../../../utils';
import DateRangePicker from '../DateRangePicker';

const minDate = getMinDate('01/01/1996');
const maxDate = getNowDateFormatWithoutTime();

export default class ExpenseFilter extends PureComponent {

    handleChangeDate = name => date => {
        const stateDate = date?.clone().utc(true).format();
        this.props.handleChangeDates(name, stateDate);
    };

    render() {
        const { startDate, endDate, loading, handleErrorDate, errors, t } = this.props;

        return (
            <DateRangePicker
                startName="stateStartDate"
                endName="stateEndDate"
                title="periodDate"
                minDate={minDate}
                maxDate={maxDate}
                value={{
                    startDate: startDate ? dayjs(startDate) : null,
                    endDate: endDate ? dayjs(endDate) : null
                }}
                handleChangeStartDate={this.handleChangeDate}
                handleChangeEndDate={this.handleChangeDate}
                handleError={handleErrorDate}
                errors={errors}
                disabled={loading}
                t={t}
            />
        );
    }
}

ExpenseFilter.propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    handleChangeDates: PropTypes.func.isRequired,
    handleErrorDate: PropTypes.func.isRequired,
    errors: PropTypes.object
};
